import { useMemo, useState } from 'react';

export const useWorkerSearch = (workers: string[][] | undefined) => {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredWorkers = useMemo(() => {
    if (!workers) {
      return [];
    }

    const uniqueWorkers = Array.from(new Set(workers.flat()));

    if (!searchTerm) {
      return uniqueWorkers;
    }

    const lowerSearchTerm = searchTerm.toLowerCase();
    return uniqueWorkers.filter((worker) =>
      worker.toLowerCase().includes(lowerSearchTerm)
    );
  }, [workers, searchTerm]);

  return { filteredWorkers, searchTerm, setSearchTerm };
};
